/* Celeste Jewel layer for Flex 7: delivery window, variant price (button, sticky bar, Afterpay), option tiles,
   read the card pill, details tabs, sticky bar, error announcements. No dependencies. */
(function () {
  'use strict';

  function addBusinessDays(date, days) {
    var d = new Date(date.getTime());
    var added = 0;
    while (added < days) {
      d.setDate(d.getDate() + 1);
      var wd = d.getDay();
      if (wd !== 0 && wd !== 6) added++;
    }
    return d;
  }
  function fmt(d) { return d.toLocaleDateString('en-US', { weekday: 'short', month: 'short', day: 'numeric' }); }
  function isoLocal(d) {
    var p = function (n) { return (n < 10 ? '0' : '') + n; };
    return d.getFullYear() + '-' + p(d.getMonth() + 1) + '-' + p(d.getDate());
  }
  /* QA only: ?cj_date=YYYY-MM-DD previews the dates and the Christmas line for another day. */
  function today() {
    var m = /[?&]cj_date=(\d{4})-(\d{2})-(\d{2})/.exec(location.search);
    return m ? new Date(+m[1], +m[2] - 1, +m[3], 12) : new Date();
  }

  function initDelivery(el) {
    var n = function (k) { return parseInt(el.getAttribute('data-' + k), 10) || 0; };
    var now = today();
    var early = addBusinessDays(now, n('make-min') + n('ship-min'));
    var late = addBusinessDays(now, n('make-max') + n('ship-max'));
    var eta = el.querySelector('[data-cj-eta]');
    if (eta) {
      eta.textContent = 'Arrives ' + fmt(early) + ' to ' + fmt(late);
      eta.hidden = false;
    }
    var cut = el.querySelector('[data-cj-cutoff]');
    var cutoff = el.getAttribute('data-cutoff');
    var from = el.getAttribute('data-cutoff-from');
    if (cut && cutoff && from) {
      var d = isoLocal(now);
      cut.hidden = !(d >= from && d <= cutoff);
    }
  }

  /* Price, Afterpay and option tiles follow the selected variant. */
  function money(cents, short) {
    if (short && cents % 100 === 0) return '$' + (cents / 100).toFixed(0);
    return '$' + (cents / 100).toFixed(2);
  }
  function initVariantUi() {
    var wrap = document.querySelector('.product-main .product_form[data-product]') || document.querySelector('.product_form[data-product]');
    if (!wrap) return;
    var product;
    try { product = JSON.parse(wrap.getAttribute('data-product')); } catch (e) { return; }
    if (!product || !product.variants) return;
    var form = wrap.querySelector('form');
    var last = null;
    /* Flex trims data-product to the selected variant; the full list comes from /products/<handle>.js. */
    if (window.fetch && product.handle) {
      fetch('/products/' + encodeURIComponent(product.handle) + '.js', { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (full) { if (full && full.variants && full.variants.length) { product = full; update(true); } })
        .catch(function () {});
    }

    function current() {
      var idInput = form && form.querySelector('[name="id"]');
      var id = idInput ? String(idInput.value) : '';
      for (var i = 0; i < product.variants.length; i++) if (String(product.variants[i].id) === id) return product.variants[i];
      return product.variants[0];
    }
    function variantWith(base, idx, value) {
      for (var i = 0; i < product.variants.length; i++) {
        var v = product.variants[i], ok = true;
        for (var j = 0; j < v.options.length; j++) {
          var want = j === idx ? value : base.options[j];
          if (v.options[j] !== want) { ok = false; break; }
        }
        if (ok) return v;
      }
      return null;
    }
    function decorate(v) {
      if (!form || product.variants.length < 2) return;
      var sets = form.querySelectorAll('.kit-product-variant-picker fieldset');
      sets.forEach(function (fs, idx) {
        var legend = fs.querySelector('.kit-fieldset__legend-text') || fs.querySelector('legend');
        var name = legend ? legend.textContent.trim() : '';
        var isBox = /box/i.test(name);
        var radios = fs.querySelectorAll('input[type="radio"]');
        if (!radios.length) return;
        var cur = fs.querySelector('.cj-opt-current');
        if (legend && !cur) { cur = document.createElement('span'); cur.className = 'cj-opt-current'; legend.appendChild(cur); }
        if (cur) cur.textContent = v.options[idx] || '';
        var prices = [];
        var images = {};
        radios.forEach(function (r) {
          var m = variantWith(v, idx, r.value);
          if (m) prices.push(m.price);
          if (m && m.featured_image) images[m.featured_image.src] = true;
        });
        var min = Math.min.apply(null, prices);
        var distinctImages = Object.keys(images).length > 1 && !isBox;
        radios.forEach(function (r) {
          var label = r.closest('label') || fs.querySelector('label[for="' + r.id + '"]');
          var btn = label && (label.querySelector('.kit-button') || label);
          if (!btn) return;
          var m = variantWith(v, idx, r.value);
          var meta = btn.querySelector('.cj-opt-meta');
          if (!meta) {
            var textWrap = document.createElement('span');
            textWrap.className = 'cj-opt-text';
            while (btn.firstChild) textWrap.appendChild(btn.firstChild);
            btn.appendChild(textWrap);
            meta = document.createElement('small');
            meta.className = 'cj-opt-meta';
            textWrap.appendChild(meta);
          }
          if (!m) { meta.textContent = ''; return; }
          if (isBox) meta.textContent = m.price > min ? 'Add ' + money(m.price - min, true) : 'Included';
          else meta.textContent = money(m.price);
          var sw = btn.querySelector('.cj-sw');
          if (distinctImages && m.featured_image) {
            if (!sw) { sw = document.createElement('i'); sw.className = 'cj-sw'; sw.setAttribute('aria-hidden', 'true'); btn.insertBefore(sw, btn.firstChild); }
            var src = m.featured_image.src;
            src = (src.indexOf('//') === 0 ? 'https:' + src : src) + (src.indexOf('?') > -1 ? '&' : '?') + 'width=160';
            sw.style.backgroundImage = 'url("' + src + '")';
          } else if (sw) { sw.remove(); }
        });
      });
    }
    function key(v) { return v.id + ':' + (form ? form.querySelectorAll('.cj-opt-meta').length : 0); }
    function update(force) {
      var v = current();
      if (force !== true && key(v) === last) return;
      document.querySelectorAll('[data-cj-atc-price]').forEach(function (el) { el.setAttribute('data-cj-atc-price', money(v.price)); });
      document.querySelectorAll('.cj-sticky__price').forEach(function (el) { el.textContent = money(v.price); });
      document.querySelectorAll('[data-cj-afterpay-price]').forEach(function (el) { el.textContent = money(v.price); });
      decorate(v);
      last = key(v);
    }
    update(true);
    if (form) form.addEventListener('change', function () { setTimeout(function () { update(true); }, 60); });
    setInterval(update, 500);
  }

  /* "Read the card" pill on the main photo, only when the card section exists. It sits in the
     gallery wrapper (not inside the Flickity slider, which would turn it into a slide) and is
     placed over the bottom left corner of the photo on screen. */
  function initReadCard() {
    var card = document.getElementById('cj-card');
    var main = document.querySelector('.product-main .product-gallery__main') || document.querySelector('.product-gallery__main');
    if (!card || !main || !main.parentElement || main.parentElement.querySelector('.cj-readcard')) return;
    var box = main.parentElement;
    var a = document.createElement('a');
    a.className = 'cj-readcard';
    a.href = '#cj-card';
    a.innerHTML = '<svg class="cj-icon" viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M4 5h16v14H4z"/><path d="M8 9h8M8 12h8M8 15h5"/></svg><span>Read the card</span>';
    if (getComputedStyle(box).position === 'static') box.style.position = 'relative';
    box.appendChild(a);
    function place() {
      var img = main.querySelector('.is-selected img') || main.querySelector('img');
      if (!img) return;
      var r = img.getBoundingClientRect(), c = box.getBoundingClientRect();
      if (!r.height) return;
      a.style.top = Math.round(r.bottom - c.top - a.offsetHeight - 12) + 'px';
      a.style.left = Math.round(Math.max(r.left - c.left, 0) + 12) + 'px';
    }
    place();
    window.addEventListener('resize', place);
    window.addEventListener('load', place);
    setInterval(place, 1000);
  }

  /* Buy with Shop drops personalization properties, so it is hidden on personalized products only.
     The class is added once a Teeinblue (layer-*) or native personalization field exists. */
  function initPersonalizationFlag() {
    var forms = document.querySelectorAll('.product_form');
    if (!forms.length) return;
    function mark() {
      forms.forEach(function (f) {
        if (f.querySelector('[name^="layer-"], #tee-artwork-form, [data-cj-native-fields], [data-cj-photo], [name="properties[_tib_design_link_1]"]')) f.classList.add('cj-has-personalization');
      });
    }
    mark();
    new MutationObserver(mark).observe(document.body, { childList: true, subtree: true });
  }

  /* Details: tabs on desktop over the same <details> panels the phone shows as accordions. */
  function initTabs() {
    document.querySelectorAll('[data-cj-tabs]').forEach(function (box) {
      var tabs = Array.prototype.slice.call(box.querySelectorAll('[role="tab"]'));
      function select(tab) {
        tabs.forEach(function (t) {
          var on = t === tab;
          t.setAttribute('aria-selected', on ? 'true' : 'false');
          t.tabIndex = on ? 0 : -1;
          var panel = document.getElementById(t.getAttribute('aria-controls'));
          if (panel) panel.open = on;
        });
      }
      tabs.forEach(function (t, i) {
        t.tabIndex = i === 0 ? 0 : -1;
        t.addEventListener('click', function () { select(t); });
        t.addEventListener('keydown', function (e) {
          var n = null;
          if (e.key === 'ArrowRight') n = tabs[(i + 1) % tabs.length];
          if (e.key === 'ArrowLeft') n = tabs[(i - 1 + tabs.length) % tabs.length];
          if (n) { e.preventDefault(); select(n); n.focus(); }
        });
      });
      box.setAttribute('data-cj-tabs-ready', '');
    });
  }

  /* The bar never submits: it takes the buyer to the personalization first. */
  function initSticky() {
    var bar = document.querySelector('[data-cj-sticky]');
    var form = document.querySelector('.product-main .product_form form') || document.querySelector('.product_form form, form[action*="/cart/add"]');
    if (!bar || !form) return;
    var submit = form.querySelector('button[type="submit"], [name="add"]');
    if (!submit) return;
    document.body.classList.add('cj-has-sticky');
    // Show only after the buyer has scrolled past the add to bag button, never above it.
    // A passive scroll check (not IntersectionObserver alone) so it also works in
    // background tabs and embedded previews where observers are throttled.
    var ticking = false;
    function update() {
      ticking = false;
      bar.hidden = submit.getBoundingClientRect().bottom > 0;
    }
    window.addEventListener('scroll', function () {
      if (!ticking) { ticking = true; (window.requestAnimationFrame || setTimeout)(update); }
    }, { passive: true });
    window.addEventListener('scroll', function () { if (document.hidden) update(); }, { passive: true });
    window.addEventListener('resize', update);
    // App galleries and fields change the button position after the theme initializes.
    if (window.ResizeObserver) new ResizeObserver(update).observe(form);
    new MutationObserver(update).observe(form, { childList: true, subtree: true });
    update();
    bar.querySelector('[data-cj-sticky-go]').addEventListener('click', function () {
      var target = document.querySelector('[data-cj-personalize-first], #tib-root input, #tib-root textarea, .customily-container input, .product_form input[type="text"], .product_form textarea') || submit;
      target.scrollIntoView({ behavior: 'smooth', block: 'center' });
      setTimeout(function () { target.focus({ preventScroll: true }); }, 350);
    });
  }

  /* Connect Teeinblue's visible headings to its inputs without changing their wording. */
  function initPersonalizerLabels() {
    function labelFields() {
      document.querySelectorAll('#tee-artwork-form .tee-field').forEach(function (field) {
        var heading = field.querySelector('.tee-field__heading');
        if (!heading || !heading.textContent.trim()) return;
        if (!heading.id) heading.id = field.id + '-cj-label';
        field.querySelectorAll('input:not([type=hidden]), select, textarea').forEach(function (control) {
          if (!control.getAttribute('aria-label') && !control.getAttribute('aria-labelledby') && !(control.labels && control.labels.length)) {
            control.setAttribute('aria-labelledby', heading.id);
          }
        });
      });
    }
    labelFields();
    new MutationObserver(labelFields).observe(document.body, { childList: true, subtree: true });
  }

  /* Announce form errors to screen readers. */
  function initAnnouncer() {
    var live = document.createElement('div');
    live.className = 'cj-sr';
    live.setAttribute('role', 'status');
    live.setAttribute('aria-live', 'polite');
    live.setAttribute('data-cj-live', '');
    document.body.appendChild(live);
    function say(msg) { live.textContent = ''; setTimeout(function () { live.textContent = msg; }, 50); }
    window.cjAnnounce = say;
    document.querySelectorAll('.product_form .warning, .product_form [data-error-message], .cart-warning, .cart__warning').forEach(function (t) {
      new MutationObserver(function () {
        var msg = (t.textContent || '').trim();
        if (msg) say(msg);
      }).observe(t, { childList: true, characterData: true, subtree: true });
    });
    /* Native validation on required personalization fields: say what is missing. */
    document.addEventListener('invalid', function (e) {
      var f = e.target;
      var label = f.labels && f.labels[0] ? f.labels[0].textContent.trim() : (f.getAttribute('aria-label') || 'This field');
      say(label + ': ' + f.validationMessage);
    }, true);
  }

  /* Flex lazy loads every image through image-element, the header and mobile logos too, so on
     phones the brand mark could sit at opacity 0 until lazysizes noticed it (seen 2026-10-22).
     The logo is above the fold on every page: load it now. */
  function initLogo() {
    document.querySelectorAll('img.primary-logo[data-src]').forEach(function (img) {
      if (img.classList.contains('lazyloaded')) return;
      if (window.lazySizes && window.lazySizes.loader) {
        window.lazySizes.loader.unveil(img);
      } else {
        var srcset = img.getAttribute('data-srcset');
        if (srcset) img.setAttribute('srcset', srcset);
        img.src = img.getAttribute('data-src');
      }
    });
  }

  function init() {
    document.querySelectorAll('[data-cj-delivery]').forEach(initDelivery);
    /* Presentation helpers must never stop the sticky bar or the announcer from starting. */
    [initLogo, initVariantUi, initReadCard, initTabs, initPersonalizationFlag].forEach(function (fn) { try { fn(); } catch (e) { /* keep going */ } });
    initSticky();
    initAnnouncer();
    initPersonalizerLabels();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
